/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Icon_Star1Inputs */

const vi_sitesettings_icon_star1 = /** @type {(inputs: Sitesettings_Icon_Star1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngôi sao`)
};

/**

* @param {Sitesettings_Icon_Star1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_icon_star1 = /** @type {((inputs?: Sitesettings_Icon_Star1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Icon_Star1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_icon_star1(inputs)
});
export { sitesettings_icon_star1 as "siteSettings_icon_star" }